import { render, staticRenderFns } from "./EquipamentoEsterilizacao.vue?vue&type=template&id=22c71aae&"
import script from "./EquipamentoEsterilizacao.vue?vue&type=script&lang=js&"
export * from "./EquipamentoEsterilizacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports